(() => {
  const loader = document.querySelector('[data-fv-site-loader]');
  if (!loader) return;

  const BOOT_KEY = 'furavoraSiteBootSeenV2';
  const isThemeEditor = Boolean(window.Shopify?.designMode) || document.documentElement.classList.contains('shopify-design-mode');
  let seen = false;
  try { seen = sessionStorage.getItem(BOOT_KEY) === '1'; } catch (_error) {}

  // No loader on internal navigation, refreshes in the same tab/session, or Theme Editor.
  if (seen || isThemeEditor || document.documentElement.classList.contains('fv-site-boot-seen')) {
    loader.remove();
    document.documentElement.classList.remove('fv-site-is-loading');
    return;
  }

  try { sessionStorage.setItem(BOOT_KEY, '1'); } catch (_error) {}

  const startedAt = performance.now();
  let hidden = false;
  const hide = () => {
    if (hidden) return;
    const elapsed = performance.now() - startedAt;
    const minimumVisible = 320;
    if (elapsed < minimumVisible) {
      window.setTimeout(hide, minimumVisible - elapsed);
      return;
    }
    hidden = true;
    loader.classList.add('is-hiding');
    document.documentElement.classList.remove('fv-site-is-loading');
    window.setTimeout(() => loader.remove(), 220);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hide, { once: true });
  else hide();

  // Failsafe: never let a slow asset trap the visitor on the opening screen.
  window.setTimeout(hide, 1200);
  window.addEventListener('pageshow', (event) => { if (event.persisted) hide(); }, { once: true });
})();
